import React, { useState } from "react";
import {
  Typography,
  useMediaQuery,
  Link,
  Stack,
  Button,
  Box,
} from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import { HashLink } from "react-router-hash-link";
import { Link as RouterLink } from "react-router-dom";
import ConnectWallet from "./ConnectWallet";
import DrawerComponent from "./Drawer";

const HeaderWrapperStyle = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  borderBottom: "1px solid #ffffff80",
  padding: "10px",
  width: "100%",
  position: "fixed",
  top: 0,
  left: 0,
  zIndex: 999,
  backgroundColor: "#000",
}));

const HeaderStyle = styled("p")(({ theme }) => ({
  fontSize: "70px",
  fontFamily: "Helvetica",
  fontWeight: 700,
}));

const HeaderContentStyle = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  padding: "10px",
  position: "fixed",
  top: "91px",
  left: 0,
  zIndex: 999,
  backgroundColor: "#000",
  width: "100%",
  height: "100%",
}));

const HeaderListStyle = styled(RouterLink)(({ theme }) => ({
  color: "#fff",
  textDecoration: "none",
  fontSize: "50px",
  fontFamily: "Helvetica",
  fontWeight: 700,
  marginBottom: "10px",
}));

export default function Header({
  web3Modal,
  loadWeb3Modal,
  logoutOfWeb3Modal,
  text,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isDesktop = useMediaQuery(theme.breakpoints.up("sm"));

  const [mobilemenuOpen, setMobileMenuOpen] = useState(false);
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobilemenuOpen);
  };

  return (
    <>
      {isDesktop && (
        <div className="header">
          <div className="connectwallet-btn">
            <ConnectWallet
              web3Modal={web3Modal}
              loadWeb3Modal={loadWeb3Modal}
              logoutOfWeb3Modal={logoutOfWeb3Modal}
            />
          </div>
          <div className="mainmenu">
            {isMobile ? (
              <DrawerComponent />
            ) : (
              <div className="desktopMenu">
                <ul>
                  <li>
                    <HashLink to="/about">ABOUT</HashLink>
                  </li>
                  <li>
                    <HashLink to="/roadmap">ROADMAP</HashLink>
                  </li>
                  <li>
                    <HashLink to="/membership">MEMBERSHIP</HashLink>
                  </li>
                  <li>
                    <HashLink to="/culturemaker">CULTURE MAKER</HashLink>
                  </li>
                  <li>
                    <HashLink to="/memories">MEMORIES</HashLink>
                  </li>
                  <li>
                    <HashLink to="/team">TEAM</HashLink>
                  </li>
                  <li>
                    <HashLink to="/mint">MINT</HashLink>
                  </li>
                  <li>
                    <HashLink to="/education">EDUCATION</HashLink>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
      )}
      {!isDesktop && (
        <>
          <HeaderWrapperStyle>
            {text == "R/HOOD" && (
              <Box
                component="img"
                src="/assets/map.png"
                width="60px"
                height="60px"
                sx={{ mr: 3 }}
              />
            )}
            <HeaderStyle onClick={() => toggleMobileMenu()}>{text}</HeaderStyle>
            {text != "R/HOOD" && (
              <Box
                component="img"
                src="/assets/map.png"
                width="30px"
                height="30px"
                sx={{ position: "absolute", right: "10px", bottom: "-40px" }}
              />
            )}
          </HeaderWrapperStyle>
          {mobilemenuOpen && (
            <HeaderContentStyle>
              <HeaderListStyle to="/about">About</HeaderListStyle>
              <HeaderListStyle to="/membership">MEMBERS</HeaderListStyle>
              <HeaderListStyle to="/team">THE TEAM</HeaderListStyle>
              <HeaderListStyle to="/mint">MINT</HeaderListStyle>
              <HeaderListStyle to="/culturemaker">TOKEN</HeaderListStyle>
              <HeaderListStyle to="/roadmap">ROADMAP</HeaderListStyle>
            </HeaderContentStyle>
          )}
        </>
      )}
    </>
  );
}
